// import ButtonComponent from 'components/atoms/ButtonComponent';
import { Button, Row } from 'antd';
import TranslateText from 'components/hoc/TranslateText';
import StatementWrapper from 'components/molecules/StatementWrapper';
import moment from 'moment';
import React from 'react';
import { useParams } from 'react-router-dom';
import bankidApi from 'services/bankid/bankid';
import nuBankidApi from 'services/nezarazenyUcet/nuDedictvi';
import { nzBankidApi } from 'services/nezarazenyUcet/nuZapis';

interface IChyba {}

const Chyba: React.FC<IChyba> = () => {
    const { chyba, datum } = useParams<{ chyba: string; datum: string }>();
    const chybaParams = chyba.split('-');
    const chybaMsg = chybaParams.length > 1 ? 'nepredaneparametry' : chyba;

    // presmerovanie momentalne nefunguje docasne schovavame button
    const routeChange = () => {
        if (datum && chyba !== 'limit') {
            window.location.hash.includes('zapis')
                ? nzBankidApi(datum)
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      .then((resp: any) => {
                          window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID
                      })
                : window.location.hash.includes('zjisteni')
                ? nuBankidApi(datum)
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      .then((resp: any) => {
                          window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID
                      })
                : bankidApi('INFO', datum)
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      .then((resp: any) => {
                          window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID
                      });
        }
    };

    return (
        <StatementWrapper pageTitle="">
            <h1>
                <TranslateText>{datum && chyba === 'limit' ? 'UPOZORNENI' : 'CHYBA_NADPIS'}</TranslateText>
            </h1>
            <TranslateText>{chybaMsg ? 'CHYBA_' + chybaMsg.toUpperCase() : 'CHYBA_OBECNA'}</TranslateText>
            <span>{datum && chyba === 'limit' ? ` ${moment(datum).format('DD.MM.YYYY')}` : ''}</span>
            {datum && chyba !== 'limit' && (
                <Row className="statement-buttons-row">
                    <Button type="primary" onClick={routeChange}>
                        <TranslateText>PRIHLASIT_SE_PPRES_BANKID</TranslateText>
                    </Button>
                </Row>
            )}
        </StatementWrapper>
    );
};

export default Chyba;
